/**
 * Описание столбцов таблицы «Воронки уровней»
 * =============================================
 *
 * Вынесено из LevelFunnelTable.js: один и тот же набор из 11 метрик рисуется
 * один раз для campaign/elite/absorption и трижды (Easy/Normal/Hard) для TD —
 * дублировать разметку колонок под каждый режим было бы источником рассинхрона.
 *
 * Каждый столбец — { key, label, hint, get(group, base, showAbs) }, где
 * `group` — один элемент row.groups (all | easy | normal | hard), `base` —
 * знаменатель funnel (row.uniqueStartersAny/base не привязан к группе, но для
 * TD-блоков считаем funnel по стартам конкретной сложности — единственная
 * трактовка, которая переиспользует общий набор столбцов и для TD).
 */

import { levelFunnel as levelFunnelSpecs } from '@ggstat/chart-specs';
import { fmtInt, fmtPct } from './format';

// Подписи и подсказки — общие с MCP (levelFunnel.json → tableColumns); здесь только значения ячеек.
const { tableColumns } = levelFunnelSpecs;

/** Склеивает подписи спецификации с функциями значения по ключу. */
function withGetters(specColumns, getters) {
  return specColumns.map((col) => (getters[col.key] ? { ...col, get: getters[col.key] } : { ...col }));
}

const decided = (g) => (g.wins || 0) + (g.losses || 0);

/** Русский заголовок + техническое имя (в title) + значение ячейки. */
export const GROUP_METRIC_COLUMNS = withGetters(tableColumns.group, {
  uniqueStarters: (g) => fmtInt(g.uniqueStarters),
  uniqueWinners: (g) => fmtInt(g.uniqueWinners),
  funnel: (g, base, showAbs) => fmtPct(g.uniqueStarters, base, showAbs),
  uniqueLosers: (g) => fmtInt(g.uniqueLosers),
  starts: (g) => fmtInt(g.starts),
  wins: (g) => fmtInt(g.wins),
  losses: (g) => fmtInt(g.losses),
  uniqueWinrate: (g, base, showAbs) => fmtPct(g.uniqueWinners, g.uniqueStarters, showAbs),
  uniqueLoserate: (g, base, showAbs) => fmtPct(g.uniqueLosers, g.uniqueStarters, showAbs),
  winrate: (g, base, showAbs) => fmtPct(g.wins, decided(g), showAbs),
  loserate: (g, base, showAbs) => fmtPct(g.losses, decided(g), showAbs)
});

/** Скип-столбцы — только campaign/elite (D2: hole_core_stage p2int=5). */
export const SKIP_COLUMNS = withGetters(tableColumns.skip, {
  skips: (g) => fmtInt(g.skips),
  uniqueSkippers: (g) => fmtInt(g.uniqueSkippers),
  uniqueSkiprate: (g, base, showAbs) => fmtPct(g.uniqueSkippers, g.uniqueStarters, showAbs)
});

/** Доп. столбцы поглощения (row.absorption), после основных 11; значения считает LevelFunnelTable. */
export const ABSORPTION_EXTRA_COLUMNS = withGetters(tableColumns.absorption, {});
